module.exports = __webpack_public_path__ + "static/media/logotrans.630d19b5.png";